import React from "react";

import HexAuthWrapper from "../../components/HexAuthWrapper";
import WithdrawalsRoute from "../../features/finance/WithdrawalsRoute";

const FinanceWithdrawalsPage = () => (
  <div className="finance-withdrawals-page full-bleed">
    <HexAuthWrapper>
      <WithdrawalsRoute />
    </HexAuthWrapper>
  </div>
);

export default FinanceWithdrawalsPage;
